import { tokens } from '@welbe/web-design-system'
import styled from 'styled-components'

export const LabelComponent = styled.label`
	font-family: ${tokens.font_family_primary};
	font-size: 16px;
	font-weight: 600;
	color: ${tokens.color_gray_dark};
	margin: 0;
`
